import request from '@/utils/axios'
import qs from 'qs'

/**
 * 获取校区列表
 * @param {*} params 
 */
export function getShowList(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/show/getshowlist',
        method: 'post',
        data: data
    })
}

/**
 * 增加栏目照片
 * @param {} params 
 * @returns 
 */
export function addActionPicture(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/show/addactionpicture',
        method: 'post',
        data: data
    })
}

export function uploadPicture(params) {
    // let data = qs.stringify(params)
    return request({
        url: '/api/manager/file/uploadPhotos',
        method: 'post',
        // headers: {
        //     'Content-Type': 'application/x-www-form-urlencoded'
        // },
        data: params
    })
}

/**
 * 删除图片
 * @param {*} params 
 */
export function deletePicture(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/show/deleteactionpicture',
        method: 'post',
        data: data
    })
}

/**
 * 添加栏目
 * @param {*} params 
 */
export function addActiontype(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/show/addactiontype',
        method: 'post',
        data: data
    })
}

/**
 * 编辑栏目
 * @param {*} params 
 */
export function editActiontype(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/show/editactiontype',
        method: 'post',
        data: data
    })
}

/**
 * 删除栏目
 * @param {*} params 
 */
export function deleteActiontype(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/show/deleteactiontype',
        method: 'post',
        data: data
    })
}